/** Renew before expiry to allow for request latency and clock differences. */
export const FILE_URL_EXPIRY_MARGIN_RATIO = 0.1;
export const FILE_URL_MAX_EXPIRY_MARGIN_MS = 30_000;

/** Attachment metadata freshness is independent of signed URL expiry. */
export const ENTRY_ATTACHMENT_STALE_TIME_MS = 60_000;

/** Square image cards render at about 150 CSS px (up to ~300 px on narrow screens): 2× the usual size. */
export const IMAGE_THUMBNAIL_SIZE = 320;
export const IMAGE_THUMBNAIL_QUALITY = 0.7;
